import { render, staticRenderFns } from "./InventoryRecordView.vue?vue&type=template&id=19dc545e&scoped=true&"
import script from "./InventoryRecordView.vue?vue&type=script&lang=js&"
export * from "./InventoryRecordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc545e",
  null
  
)

export default component.exports